import { useNavigate } from 'react-router-dom';
import { routes } from '@/lib/routes';
import { SuperAiWorkspaceModal } from '@/features/super-ai/components/SuperAiWorkspaceModal';

/** Owner Super AI — canonical workspace modal (Block 12). */
export const OwnerSuperAiPage = () => {
  const navigate = useNavigate();

  return (
    <SuperAiWorkspaceModal
      isOpen
      onClose={() => navigate(routes.owner)}
      activeRole="SYSTEM_OWNER"
    />
  );
};
